module.exports = __webpack_public_path__ + "img/azvi-full.dff3a562.png";